import React, { Component } from "react";
import { Link } from "react-router-dom";

import FullWidthCard from "@/components/FullWidthCard";
import LazyLoadImage from "@/components/atoms/LazyLoadImage";
import tracking from "@/utils/tracking";
import {
	IMAGE,
	HEADER_COPY,
	BODY_COPY,
	CTA_COPY,
	CTA_LINK
} from "@/utils/content-keys";

import "./feature.scss";

class Feature extends Component {
	state = { visible: false };

	lazyComponentUpdate() {
		if (!this.state.visible) {
			this.setState({ visible: true });
		}
	}
	
	render() {
		const {
			className,
			reverse,
			article,
			colReverse,
			noGutters,
			index
		} = this.props;

		return (
			<div
				className={`${className} ${
					this.state.visible ? "feature--active" : ""
					}`}
			>
				<FullWidthCard
					reverse={reverse}
					colReverse={colReverse}
					noGutters={noGutters}
					key={`${className}_${index}`}
				>
					<div className="feature__copy-wrapper col-12 col-sm-6 align-self-start">
						<h3 role="heading" aria-level="2" className="feature__title" dangerouslySetInnerHTML={{__html: article[HEADER_COPY].value}} />
						<p className="feature__copy" dangerouslySetInnerHTML={{__html: article[BODY_COPY].value}} />
						{(article[CTA_COPY]
							&& article[CTA_COPY].value) ?
							<a className="cta cta--feature d-none d-sm-inline-block" href={article[CTA_LINK].value}>
								{article[CTA_COPY].value}</a>
							:
							(article[CTA_LINK]
								&& article[CTA_LINK].value.startsWith("http")) ?
								<Link
									className="cta cta--feature d-none d-sm-inline-block"
									to={article[CTA_LINK].value}
									onClick={() => {
										tracking.event("custom", {
											eventCategory: "Link",
											eventAction: "click",
											eventLabel: `Homepage - URL: ${article[CTA_LINK].value}`
										});
									}}
								>
									{article[CTA_COPY].value}
								</Link>
								:
								''
 								}

					</div>

					<div className="feature__image-wrapper col-12 col-sm-6">

						{article[IMAGE] && article[IMAGE].length == 2 && (
							<LazyLoadImage
								src={article[IMAGE][0].imgURL}
								srcset={`${article[IMAGE][1].imgURL} 750w, ${
									article[IMAGE][0].imgURL
									} 1984w`}
								lazyCallback={() => this.lazyComponentUpdate()}
								className="feature__image"
								alt={article[IMAGE][0].alternateText}
							/>
						)}

						{article[IMAGE] && article[IMAGE].length != 2 && (
							<LazyLoadImage
								src={article[IMAGE].imgURL}
								lazyCallback={() => this.lazyComponentUpdate()}
								className="feature__image"
								alt={article[IMAGE].alternateText}
							/>
						)}

						{(article[CTA_COPY]
							&& article[CTA_COPY].value) ?
							<a className="cta cta--feature cta--mobile d-sm-none" href={article[CTA_LINK].value}>
								{article[CTA_COPY].value}</a>
							:
							(article[CTA_LINK]
								&& article[CTA_LINK].value.startsWith("http")) ?
								<Link
									className="cta cta--feature cta--mobile d-sm-none"
									to={article[CTA_LINK].value}
									onClick={() => {
										tracking.event("custom", {
											eventCategory: "Link",
											eventAction: "click",
											eventLabel: `Homepage - URL: ${article[CTA_LINK].value}`
										});
									}}
								>
									{article[CTA_COPY].value}
								</Link>
								:
								''
 						}
					</div>
				</FullWidthCard>
			</div>
		);
	}
}
export default Feature;



// WEBPACK FOOTER //
// ./src/components/_common/Feature/index.js